import { WSElement, WSLoader, WSText } from "@wingspanhq/fe-component-library";
import { useMemberClientQuery } from "../../../query/payments/queries";
import styles from "./InvoicesTable.module.scss";

type Props = {
  memberClientId: string;
};

export const ClientDetails: React.FC<Props> = ({ memberClientId }) => {
  const queryMemberClient = useMemberClientQuery(memberClientId);

  if (queryMemberClient.isLoading) {
    return (
      <WSElement className={styles.spinner}>
        <WSLoader.Spinner size="XS" />
      </WSElement>
    );
  }

  if (!queryMemberClient.data) {
    return null;
  }

  const memberClient = queryMemberClient.data;

  return (
    <WSElement>
      <WSText mb={memberClient.name ? "XS" : undefined} color="gray600">
        {memberClient.company || memberClient.emailTo}
      </WSText>
      <WSText.ParagraphXs color="gray500">
        {memberClient.name}
      </WSText.ParagraphXs>
    </WSElement>
  );
};
